var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var axios = require('axios');
export var initDateSetting = function (column) {
    column.getElement().querySelectorAll('[data-setting=date]').forEach(function (setting) { return new DateSetting(column, setting); });
};
var DateSetting = /** @class */ (function () {
    function DateSetting(column, setting) {
        this.column = column;
        this.setting = setting;
        this.options = this.setting.querySelectorAll('.radio-labels input[type=radio]');
        this.defaultFormat = this.setting.querySelector('.radio-labels code').textContent;
        this.valueInput = this.setting.querySelector('[data-value-input]');
        // @ts-ignore
        var customInput = __spread(this.options).filter(function (radio) { return radio.value === 'custom'; });
        this.customOption = new CustomOption(customInput[0], this.setting.querySelector('[data-custom-date]'), this.setting.querySelector('.ac-setting-input-date__example'), this.valueInput);
        this.initEvents();
    }
    DateSetting.prototype.getOptionsAsArray = function () {
        return Array.from(this.options);
    };
    DateSetting.prototype.getSelectionOption = function () {
        var selected = this.getOptionsAsArray().filter(function (option) { return option.checked; });
        return selected ? selected[0] : null;
    };
    DateSetting.prototype.initEvents = function () {
        var _this = this;
        this.options.forEach(function (radio) {
            radio.addEventListener('change', function () { return _this.handleUpdate(radio); });
            radio.addEventListener('change', function () { return _this.setCustomValue(radio.value); });
        });
        var selected = this.getSelectionOption();
        if (!selected) {
            selected = this.getOptionsAsArray().filter(function (option) { return option.value === 'wp_default'; })[0];
            selected.checked = true;
        }
        selected.dispatchEvent(new Event('change'));
    };
    DateSetting.prototype.handleUpdate = function (input) {
        this.valueInput.value = input.value;
        this.customOption.toggle(input.value === 'custom');
        this.setHelpText(this.getHelpTextFromType(input.value));
    };
    DateSetting.prototype.setCustomValue = function (type) {
        switch (type) {
            case 'diff':
                this.customOption.setCustomValue('');
                break;
            case 'custom':
                break;
            default:
                this.customOption.setCustomValue(this.defaultFormat);
        }
    };
    DateSetting.prototype.setHelpText = function (text) {
        var element = this.setting.querySelector('.help-msg');
        element.innerHTML = text;
        element.style.display = 'block';
    };
    DateSetting.prototype.getHelpTextFromType = function (type) {
        var input = this.getOptionsAsArray().filter(function (radio) { return radio.value === type; });
        if (!input) {
            return '';
        }
        var helpText = input[0].closest('label').querySelector('[data-help]');
        return helpText ? helpText.innerHTML : null;
    };
    return DateSetting;
}());
var CustomOption = /** @class */ (function () {
    function CustomOption(radio, input, example, valueElement) {
        var _this = this;
        this.radio = radio;
        this.input = input;
        this.example = example;
        this.valueElement = valueElement;
        this.input.addEventListener('change', function () { return _this.updateExample(); });
        this.input.addEventListener('keyup', function () {
            if (radio.checked) {
                _this.valueElement.value = _this.input.value;
            }
        });
    }
    CustomOption.prototype.updateExample = function () {
        var _this = this;
        this.getExample().then(function (response) {
            _this.example.innerHTML = response.data;
        });
    };
    CustomOption.prototype.toggle = function (enable) {
        if (enable === void 0) { enable = true; }
        enable
            ? this.input.removeAttribute('disabled')
            : this.input.setAttribute('disabled', 'disabled');
    };
    CustomOption.prototype.getCustomValue = function () {
        return this.input.value;
    };
    CustomOption.prototype.setCustomValue = function (format) {
        this.input.value = format;
    };
    CustomOption.prototype.getExample = function () {
        var data = new FormData();
        data.set('action', 'date_format');
        data.set('date', this.getCustomValue());
        return axios.post(ajaxurl, data, {});
    };
    return CustomOption;
}());
